import React, { useState, useEffect } from "react";
import {  Row, Col, Card, HeadingText, CaptionText, BodyText, Link, DownloadIcon, Button, LoadingSpinner } from "@paypalcorp/pp-react";
import MonthwisePayoutTable from "./MonthwisePayoutTable";
import PendingPayoutTable from "./PendingPayoutTable";
import PPGFSummaryTotal from "./PPGFSummaryTotal";
import { fetchResponse } from "../../common/serviceRequest";
import * as FPT from "../../utility/fpt";
import { get } from "lodash";
import { getPayPalDomain } from "@paypalcorp/instance-location";
import { links } from "../../../../constants/links.json";
import { parseMessages } from "../../utilityHelper";
import { FB_FUNDRAISING_COUNTRIES, EBAY_PPHERE_COUNTRIES } from "../../../../constants/constants";
import { show, hide } from '../../common/domUtils';
import ReactHtmlParser from 'react-html-parser';
import { launchRedirect } from '../../lib/validate';
import SFCtile from "./SFC/SFCtile";
import withTheme from "../../common/withTheme";
const dashboardPageMsg = parseMessages("givingfund");

const DashboardTab = ({ isDirectModel, isBrazil }) => {
  let dataObj = {};
  try {
    dataObj.country = (document.getElementById("data-country") && document.getElementById("data-country").innerHTML) || "";
    dataObj.dashboardData = JSON.parse((document.getElementById("data-charity-info") && document.getElementById("data-charity-info").innerHTML) || "{}");
    dataObj.pageDetails = JSON.parse(document.getElementById('data-page-details') && document.getElementById('data-page-details').innerHTML || '{}');

  } catch (e) {
    console.warn("Error while parsing data", e);
  }
  const eBaySalesCharity = EBAY_PPHERE_COUNTRIES.includes(dataObj.country);
  const FBFundRaisingCountry = FB_FUNDRAISING_COUNTRIES.includes(dataObj.country);

  const completedPayoutSummaryDesc = dashboardPageMsg.dashboard.completedPayoutSummaryDesc.replace('{PAYOUT_DATE}', get(dataObj, 'pageDetails.payoutDate', 25));
  const completedPayoutSummaryDescDM = dashboardPageMsg.dashboard.completedPayoutSummaryDescDM.replace('{PAYOUT_DATE}', get(dataObj, 'pageDetails.payoutDate', 25));
  const completedPayoutSummaryDescBR = dashboardPageMsg.dashboard.completedPayoutSummaryDescBR.replace('{PAYOUT_DATE}', get(dataObj, 'pageDetails.payoutDate', 25));
  const pendingPayoutSummaryDesc = dashboardPageMsg.dashboard.pendingPayoutSummaryDesc.replace('{PAYOUT_DATE}', get(dataObj, 'pageDetails.payoutDate', 25));
  const pendingPayoutSummaryDescDM = dashboardPageMsg.dashboard.pendingPayoutSummaryDescDM.replace('{PAYOUT_DATE}', get(dataObj, 'pageDetails.payoutDate', 25));
  const pendingPayoutSummaryDescBR = dashboardPageMsg.dashboard.pendingPayoutSummaryDescBR.replace('{PAYOUT_DATE}', get(dataObj, 'pageDetails.payoutDate', 25));

  const [payoutsStatus, setpayoutsStatus] = useState(null);
  const [completedPayout, setCompletedPayout] = useState(true);
  const [monthwisePayoutData, setMonthwisePayoutData] = useState([]);
  const [monthwisePayoutDataError, setMonthwisePayoutDataError] = useState(false);
  const [monthwisePayoutNoRecordsMsg, setMonthwisePayoutNoRecordsMsg] = useState(false);
  const [monthwisePayoutLoader, setMonthwisePayoutLoader] = useState(true);
  const [pendingPayoutData, setPendingPayoutData] = useState([]);
  const [pendingPayoutDataError, setPendingPayoutDataError] = useState(false);
  const [pendingPayoutNoRecordsMsg, setPendingPayoutNoRecordsMsg] = useState(false);
  const [pendingPayoutLoader, setPendingPayoutLoader] = useState(true);
  const [showPayoutDetails, setShowPayoutDetails] = useState([]);
  const [partnerwisePayoutLoader, setPartnerwisePayoutLoader] = useState({});
  const [rowId, setRowId] = useState("");
  const [partnerwisePayoutError, setPartnerwisePayoutError] = useState(false);
  const [partnerwisePayoutData, setPartnerwisePayoutData] = useState([]);
  const [loadMoreDataPD, setLoadMoreDataPD] = useState({ pageNumber: 1, scrollID: '' });
  const [summaryPageNo, setSummaryPageNo] = useState(1);
  const [favoriteCharityLoading, setFavoriteCharityLoading] = useState(false);
  const [favoriteCharityData, setFavoriteCharityData] = useState({});
  const [favoriteCharityDataError, setFavoriteCharityDataError] = useState(false);
  const [dashboardMessage, setDashboardMessage] = useState('');

  const handlePayoutSummary = (payoutName) => {
    FPT.trackButtonClick(payoutName);
    if (payoutName == "pendingPayouts") {
      setCompletedPayout(false);
      if (!pendingPayoutNoRecordsMsg) { // Dont trigger fetchResp if pendingPayout is loaded
        fetchPendingPayoutData(); // AJAX call to get Pending Donations
      }
    } else {
      setCompletedPayout(true);
    }
    setpayoutsStatus(payoutName);
  };

  const fetchPendingPayoutData = (action) => {
    hide('.loadMoreBtn');
    let params = {
      pageNo: get(loadMoreDataPD, 'pageNumber'),
      scrollID: get(loadMoreDataPD, 'scrollID'),
      _csrf: document.body.getAttribute("data-csrf")
    };
    if (action === 'loadMore') {
      FPT.trackButtonClickWithData('LoadMorePendingPayout', { pageParams: params.pageNo });
      show('.loadMoreSpinner');
    }

    fetchResponse("/givingfund/pendingDonations", "POST", params).then(function (result) {
      setPendingPayoutLoader(false);
      if (result.status != "error") {
        hide('.loadMoreSpinner');
        const donations = [...pendingPayoutData];
        setPendingPayoutData(donations.concat(get(result, "data.donation_info", [])));
        setPendingPayoutNoRecordsMsg(true);
        setLoadMoreDataPD({
          scrollID: get(result, "data.scroll_id", ''),
          pageNumber: parseInt(get(loadMoreDataPD, 'pageNumber')) + 1
        });
        result.data.scroll_id !== '' && show('.loadMoreBtn');
      } else {
        throw new Error();
      }
    }).catch(function (e) {
      console.log(e);
      hide('.loadMoreSpinner');
      setPendingPayoutDataError(true);
      setPendingPayoutNoRecordsMsg(false);
    });
  }

  const fetchMonthWisePayoutData = (action) => {
    hide('.loadMoreBtn');
    let params = {
      pageNo: summaryPageNo,
      _csrf: document.body.getAttribute("data-csrf")
    };
    if (action === 'loadMore') {
      FPT.trackButtonClickWithData('LoadMoreMonthlyPayout', { pageParams: params.pageNo });
      show('.loadMoreSpinner');
    }

    fetchResponse("/givingfund/renderMonthwisePayouts", "POST", params).then(function (result) {
      setMonthwisePayoutLoader(false);
      if (result.status != "error") {
        hide('.loadMoreSpinner');
        const payouts = [...monthwisePayoutData];
        setMonthwisePayoutData(payouts.concat(get(result, "data.payouts", [])));
        setMonthwisePayoutNoRecordsMsg(true);
        setSummaryPageNo(summaryPageNo + 1);
        get(result, "data.payouts").length > 0 && show('.loadMoreBtn');
      } else {
        throw new Error();
      }
    }).catch(function (e) {
      console.log(e);
      hide('.loadMoreSpinner');
      setMonthwisePayoutDataError(true);
      setMonthwisePayoutNoRecordsMsg(false);
    });
  }
  const fetchDonationData = (action) => {
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    const currentDate = new Date();

    const params = {
      _csrf: document.body.getAttribute("data-csrf"),
      currentDate: currentDate.toISOString().split('T')[0].replace(/-/g, ''),
      sixMonthsAgo: sixMonthsAgo.toISOString().split('T')[0].replace(/-/g, '')
    };
    setFavoriteCharityLoading(true);
    fetchResponse("/givingfund/renderDonorFavCount", "POST", params).then(function (result) {

      setFavoriteCharityLoading(false);
      if (result.status !== "error") {
        setFavoriteCharityData({ favoriteCharityMonthlyCount: result.data, favoriteCharityDonorCount: result.count, favoriteCharityDataPercentage: result.percentage })

      } else {
        setFavoriteCharityDataError(true);
        throw new Error();
      }
    }).catch(function (e) {
      console.log(e);
    });
  }
  useEffect(() => {
    FPT.trackPage('main:givingfund:dashboard');
    fetchMonthWisePayoutData('pageLoad');
    dataObj.pageDetails.sfcEnabled && fetchDonationData('pageLoad');
  }, []);

  useEffect(() => {
    dashboardMessages();
  }, [payoutsStatus, isDirectModel]);

  const handleRowExpansion = (payoutId, payoutDate) => {
    const showPartnerData = [...showPayoutDetails];
    const payoutIndex = showPartnerData.indexOf(payoutId);
    if (payoutIndex >= 0) {
      showPartnerData.splice(payoutIndex, 1);
      setShowPayoutDetails(showPartnerData);
    } else {
      const checkPartnerIndex = partnerwisePayoutLoader.hasOwnProperty(payoutId);
      const params = {
        payoutDate: payoutDate,
        _csrf: document.body.getAttribute("data-csrf"),
      };
      if (!checkPartnerIndex || partnerwisePayoutError) {
        partnerwisePayoutLoader[payoutId] = true;
        setPartnerwisePayoutLoader(partnerwisePayoutLoader);
        FPT.trackButtonClick(`partnerwisePayoutdetails|${payoutDate}`);

        fetchResponse("/givingfund/monthlyPartnerWisePayout", "POST", params).then(function (result) {
          partnerwisePayoutLoader[payoutId] = false;
          setPartnerwisePayoutLoader(partnerwisePayoutLoader);
          setRowId(payoutId);
          if (result.status != "error") {
            setPartnerwisePayoutData(result.data.payout);
          } else {
            throw new Error();
          }
        }).catch(function (e) {
          setPartnerwisePayoutError(true);
        });
      }
      showPartnerData.push(payoutId);
      setShowPayoutDetails(showPartnerData);
    }
  };

  const copyToClipboard = () => {
    const textField = document.createElement("textarea");
    textField.innerText = document.getElementById("fundraisingLink").innerText;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };

  const downloadPD = () => {
    FPT.trackButtonClick('downloadPendingDonations');
    launchRedirect('downloadPendingDonations', true);
  };

  const dashboardMessages = () => {
    switch (true) {
      case (payoutsStatus == "pendingPayouts" && isDirectModel && isBrazil):
      setDashboardMessage(ReactHtmlParser(pendingPayoutSummaryDescBR));
        break;
      case (payoutsStatus == "pendingPayouts" && isDirectModel):
      setDashboardMessage(ReactHtmlParser(pendingPayoutSummaryDescDM));
        break;
      case (payoutsStatus == "pendingPayouts"):
      setDashboardMessage(ReactHtmlParser(pendingPayoutSummaryDesc));
        break;
      case (payoutsStatus == "completedPayouts" && isDirectModel && isBrazil):
      setDashboardMessage(ReactHtmlParser(completedPayoutSummaryDescBR));
        break;
      case (payoutsStatus == "completedPayouts" && isDirectModel):
      setDashboardMessage(ReactHtmlParser(completedPayoutSummaryDescDM));
        break;
      case (payoutsStatus == "completedPayouts"):
      setDashboardMessage(ReactHtmlParser(completedPayoutSummaryDesc));
        break;
      case (isDirectModel && isBrazil):
      setDashboardMessage(ReactHtmlParser(completedPayoutSummaryDescBR));
        break;
      case (isDirectModel):
      setDashboardMessage(ReactHtmlParser(completedPayoutSummaryDescDM));
        break;
      default:
        setDashboardMessage(ReactHtmlParser(completedPayoutSummaryDesc));
    }
  }

  return (
    <>
      <section className="PayoutTotalSection">
        <PPGFSummaryTotal
          pendingPayoutNoRecordsMsg={pendingPayoutNoRecordsMsg}
          handlePayoutSummary={handlePayoutSummary}
          completedPayout={completedPayout}
          dashboardPageMsg={dashboardPageMsg}
        />
      </section>
      <section>
        <Row style={{ marginTop: "50px" }}>

          {!dataObj.pageDetails.directModel &&

          <Col xs={12} xxl={4}>

            {dataObj.pageDetails.sfcEnabled &&
              <SFCtile favoriteCharityLoading={favoriteCharityLoading} favoriteCharityDataError={favoriteCharityDataError} sfcCharityData={favoriteCharityData} />
            }
            <Card className="fundraisingSection">
              <HeadingText size="sm">{dashboardPageMsg.dashboard.resourcesTitle}</HeadingText>
              <BodyText as='p'>
                <Link href={links[dataObj.country].mpphomepage} data-fpti="aboutResourcesLink" target="_blank">
                  {dashboardPageMsg.dashboard.resources.about}
                </Link>
              </BodyText>
              {FBFundRaisingCountry &&
                <BodyText as='p'>
                  <Link data-fpti="fbResourcesLink" target="_blank" href={links.default.facebookFundRaiser}>
                    {dashboardPageMsg.dashboard.resources.fb}
                  </Link>
                </BodyText>
              }
              <BodyText as='p'>
                <Link data-fpti="gacResourcesLink" target="_blank" href={links[dataObj.country].gacAsset}>
                  {dashboardPageMsg.dashboard.resources.gac}
                </Link>
              </BodyText>
              <BodyText as='p'>
                <Link data-fpti="gfmResourcesLink" target="_blank" href={links[dataObj.country].gfmResources}>
                  {dashboardPageMsg.dashboard.resources.gfm}
                </Link>
              </BodyText>
              {eBaySalesCharity &&
                <BodyText as='p'>
                  <Link data-fpti="ebayResourcesLink" target="_blank" href={`${links[dataObj.country].ebayCharityPage}/${dataObj.dashboardData.nonprofit_id}`}>
                    {dashboardPageMsg.dashboard.resources.ebaycharity}
                  </Link>
                </BodyText>
              }

              <Row className="copyUrlSection">
                <Col >
                  <CaptionText strong>
                    {dashboardPageMsg.dashboard.fundraisingCopyUrl}
                  </CaptionText>
                  <CaptionText id="fundraisingLink" style={{ display: "none" }}>
                    {getPayPalDomain()}/{dataObj.country.toLowerCase()}
                    {links.default.fundraiser}/{dataObj.dashboardData.nonprofit_id}
                  </CaptionText>
                </Col>
                <Col md="auto" style={{ textAlign: "right" }}>
                  <Button size="sm" data-fpti="copyFundRaisingURL" secondary onClick={() => copyToClipboard()}>
                    {dashboardPageMsg.dashboard.resources.copyLink}
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
 }
          <Col xs={12} xxl={dataObj.pageDetails.directModel ? 12 : 8}>
            <Row className="payoutTableSection">
              <Col xs={12} xxl={payoutsStatus == "pendingPayouts" ? 10 : 12} className="payoutSummaryDesc">
              <BodyText>
                  {dashboardMessage}
                </BodyText>
              </Col>
              {payoutsStatus == "pendingPayouts" && (
                <Col xxl={2} className="downloadCol" style={{ textAlign: "right" }}>
                  <Link onClick={() => downloadPD()} style={{ float: 'right' }} leftIcon={<DownloadIcon style={{ color: 'black' }} name="v2-download" size="sm" />}>{get(dashboardPageMsg, 'download')}</Link>

                </Col>
              )}
            </Row>
            {payoutsStatus == "pendingPayouts" ?
              <PendingPayoutTable
                pendingPayoutData={pendingPayoutData}
                pendingPayoutNoRecordsMsg={pendingPayoutNoRecordsMsg}
                pendingPayoutLoader={pendingPayoutLoader}
                pendingPayoutDataError={pendingPayoutDataError}
                dashboardPageMsg={dashboardPageMsg}
                loadMoreDataPD={loadMoreDataPD}
              />
              :
              <MonthwisePayoutTable
                monthwisePayoutData={monthwisePayoutData}
                monthwisePayoutNoRecordsMsg={monthwisePayoutNoRecordsMsg}
                monthwisePayoutLoader={monthwisePayoutLoader}
                monthwisePayoutDataError={monthwisePayoutDataError}
                dashboardPageMsg={dashboardPageMsg}
                handleRowExpansion={handleRowExpansion}
                showPayoutDetails={showPayoutDetails}
                partnerwisePayoutLoader={partnerwisePayoutLoader}
                rowId={rowId}
                partnerwisePayoutError={partnerwisePayoutError}
                partnerwisePayoutData={partnerwisePayoutData}
              />
            }
            <section className="section loadMore">
                <Button size="sm" className="loadMoreBtn" secondary onClick={payoutsStatus == "pendingPayouts" ? () => fetchPendingPayoutData('loadMore') : () => fetchMonthWisePayoutData('loadMore')}>
                  {get(dashboardPageMsg, 'loadmore')}
                </Button>
                <LoadingSpinner className="loadMoreSpinner" id="loadMoreSpinner" size="md" screenReaderText={get(dashboardPageMsg, 'loading')} />
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default withTheme(DashboardTab);
